// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"95589dad","424":"0eef02f5"}[chunkId] + ".chunk.css";
};